import axios from "axios";
import { environment } from "../../environments/environment";
import { safePathSegment } from "../../utils/safePathSegment";

export class ResetPasswordService {
  async createNewPassword(id, formData) {
    return await axios.put(
      `${environment.endpoints.base_invoice_api_url}/passwordResetRequest/${safePathSegment(id)}`,
      formData,
      {
        headers: {},
      }
    );
  }
}

export default new ResetPasswordService();
